
import React from "react";
import classnames from 'classnames';

import G000Svg from './svgs/g000';
import G001Svg from './svgs/g001';
import G002Svg from './svgs/g002';
import G003Svg from './svgs/g003';
import G004Svg from './svgs/g004';

const css = require('./index.scss');

export default function TypeSwitch(props: {
    /** 应用分类 0-其他,1-进销一体化,2-结算协同,3-通用 */
    value?: number;

    /** 类型改变 */
    onChange?: (value: number) => void
}) {

    const [value, setValue] = React.useState(props.value);

    const onChange = React.useCallback(e => {
        if (value !== e) {
            setValue(e);
            props.onChange && props.onChange(e);
        }
    }, [value, props.onChange])

    React.useEffect(() => { setValue(props.value) }, [props.value])

    return (
        <div className={css.typeSwitch} >
            <div className={css.label} >
                <i dangerouslySetInnerHTML={{ __html: G000Svg }} />
                <span>应用推荐</span>
            </div>
            <ul className={css.tags} >
                <li>
                    <div className={classnames({ [css.selected]: value === 1 })} onClick={() => { onChange(1) }} >
                        <i dangerouslySetInnerHTML={{ __html: G001Svg }} />
                        <span>进销一体化</span>
                    </div>
                </li>

                <li>
                    <div className={classnames({ [css.selected]: value === 2 })} onClick={() => { onChange(2) }}  >
                        <i dangerouslySetInnerHTML={{ __html: G002Svg }} />
                        <span>结算协同</span>
                    </div>
                </li>

                <li>
                    <div className={classnames({ [css.selected]: value === 3 })} onClick={() => { onChange(3) }} >
                        <i dangerouslySetInnerHTML={{ __html: G003Svg }} />
                        <span>通用</span>
                    </div>
                </li>

                <li>
                    <div className={classnames({ [css.selected]: value === 0 })} onClick={() => { onChange(0) }}  >
                        <i dangerouslySetInnerHTML={{ __html: G004Svg }} />
                        <span>其他</span>
                    </div>
                </li>
            </ul>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/UI.TypeSwitch/index.tsx